//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Paginate from 'vuejs-paginate';
import { mapGetters } from 'vuex';
import TabelaGenerica from '../../../../../../shared-components/generico/TabelaGenerica';
import { getMoney } from '../../../../../../common/functions/helpers';
import StatusPassos from '../../../../../../shared-components/workflow/StatusPassos';
import FiltrosDash from './FiltrosDashOrcamento';
import { generateComputed } from '../../../../../../common/functions/roles-computed-generator';

export default {
  name: 'OrcamentoTabelaDash',
  extends: TabelaGenerica,
  components: {
    StatusPassos,
    FiltrosDash,
    Paginate,
  },
  props: {
    periodo: {
      type: Number,
      default: null,
    },
    idUnidadeNegocio: {
      type: Number,
      default: null,
    },
    carregando: Boolean,
    bloquearConsulta: Boolean,
    paginas: Number,
  },
  data() {
    return {
      workflowOrcamentoResources: this.$api.workflowOrcamento(this.$resource),
      workflowAjusteVerbaResources: this.$api.workflowAjusteVerba(this.$resource),
      workflowTransferenciaResources: this.$api.workflowTransferencia(this.$resource),
      podeAprovar: false,
      podeReprovar: false,
      primeiraBusca: false,
      objetosSelecionados: [],
      dialog: {
        ref: 'dialog1',
        from: 'saveRegisterFromButton',
        title: this.$t('label.atencao'),
        content: '',
        action() {},
      },
      motivo: '',
      justificarOrcamento: {
        observacao: '',
      },
      indexPagina: 0,
      statusPassos: {},
      filtro: {
        status: 'AGUARDANDO_APROVACAO',
        meuPassoPendente: true,
        filtro: null,
        fluxo: null,
      },
    };
  },
  computed: {
    ...mapGetters('roles', [
      'getAllRoles',
    ]),
    ...generateComputed('ORC', [
      'canAccessPage',
    ]),
    canAccessPageAjuste() {
      if (!this.getAllRoles) {
        return false;
      }
      return !!this.getAllRoles
        .filter(el => el === 'ORC_AJUSTE').length;
    },
    canAccessPageTransferir() {
      if (!this.getAllRoles) {
        return false;
      }
      return !!this.getAllRoles
        .filter(el => el === 'ORC_TRANSFERENCIA').length;
    },
  },
  methods: {
    getMoney,
    requestAbrirAcompanhamento(row) {
      const tipoOrcamento = 1,
        tipoAjuste = 3,
        tipoTransferencia = 4,
        idTipoWorkflow = row.idTipoWorkflow;

      let promise = null;
      if (idTipoWorkflow === tipoOrcamento) {
        const idOrcamento = row.idEntidade;
        promise = this.workflowOrcamentoResources.statusPasso({ idOrcamento }, { idOrcamento });
      }
      if (idTipoWorkflow === tipoAjuste) {
        const idAjuste = row.idEntidade;
        promise = this.workflowAjusteVerbaResources.statusPasso({ idAjuste }, { idAjuste });
      }
      if (idTipoWorkflow === tipoTransferencia) {
        const idTransferencia = row.idEntidade;
        promise = this.workflowTransferenciaResources.statusPasso(
          { idTransferencia }, { idTransferencia });
      }

      promise.then((res) => {
        this.statusPassos = res.data;
        this.$refs.modalAcompanhamento.open();
      })
      .catch((err) => {
        this.$toast.create(this.$t(err), 'snack', 3E3);
      });
    },
    temJustificativa(row) {
      return row.justificativa && row.justificativa !== '';
    },
    requestBuscarMotivoLog(row) {
      const id = row.idOrcamento;
      if (row) {
        if (row.idTipoWorkflow === 1) {
          this.buscarJustificativaOrcamento(id);
          return;
        }
        if (row.idTipoWorkflow === 3) {
          this.buscarJustificativaAjuste(id);
          return;
        }
        if (row.idTipoWorkflow === 4) {
          this.buscarJustificativaTransferencia(id);
        }
      }
    },
    buscarJustificativaOrcamento(idOrcamento) {
      this.workflowOrcamentoResources.status({ idOrcamento }, { idOrcamento })
        .then(this.abrirDialogJustificativa)
        .catch((err) => {
          this.$error(this, err);
        });
    },
    buscarJustificativaAjuste(idAjuste) {
      this.workflowAjusteVerbaResources.status({ idAjuste }, { idAjuste })
        .then(this.abrirDialogJustificativa)
        .catch((err) => {
          this.$error(this, err);
        });
    },
    buscarJustificativaTransferencia(id) {
      this.workflowTransferenciaResources.status({ id }, { id })
        .then(this.abrirDialogJustificativa)
        .catch((err) => {
          this.$error(this, err);
        });
    },
    clickHandler(pagina) {
      this.indexPagina = pagina - 1;
      this.$emit('DASH_ORCAMENTO_TABELA_PAGINA', this.filtro, pagina);
    },
    refazPaginacao() {
      this.indexPagina = 0;
    },
    abrirDialogJustificativa(response) {
      if (response.data && response.data.passoAtual) {
        const content = response.data.passoAtual.observacao;
        this.setDialogContent(content, null, this.dialog.from, this.$t('title.justificativa'));
        this.openDialog(this.dialog.ref);
      }
    },
    podeVisualizar(row) {
      if (row) {
        return (row.idTipoWorkflow === 1 && this.canAccessPage) ||
          (this.canAccessPageAjuste && row.idTipoWorkflow === 3) ||
          (this.canAccessPageTransferir && row.idTipoWorkflow === 4);
      }
      return false;
    },
    verItem(row) {
      if (row) {
        if (row.idTipoWorkflow === 1) {
          this.$router.push({ name: 'verOrcamentoFluxo', params: { id: row.idOrcamento } });
          return;
        }
        if (row.idTipoWorkflow === 3) {
          this.$router.push({ name: 'verAjusteVerbaFluxo', params: { id: row.idOrcamento } });
          return;
        }
        if (row.idTipoWorkflow === 4) {
          this.$router.push({ name: 'verTransferenciaFluxo', params: { id: row.idOrcamento } });
        }
      }
    },
    limparSelecao() {
      this.podeAprovar = false;
      this.podeReprovar = false;
      this.clearCheckbox();
      this.objetosSelecionados = [];
    },
    filtrar() {
      this.$emit('ORCAMENTOTABELA_FILTRAR', this.filtro, this.closeLoading);
    },
    filtrarModal(filtro) {
      this.filtro = filtro;
      this.filtrar();
    },
    openDialogJustificativaReprovar() {
      this.justificarOrcamento.observacao = '';
      this.justificarOrcamento.obrigatorio = true;
      this.justificarOrcamento.action = this.requestReprovar;

      this.openDialog('justificarDialog');
    },
    openDialogAprovar(ref, row) {
      this.objetosSelecionados = [row];
      const content = this.$t('message.deseja_aprovar');
      this.setDialogContent(content, this.requestAprovar, this.dialog.from);
      this.openDialog(ref || this.dialog.ref);
    },
    openDialogReprovar(ref, row) {
      this.objetosSelecionados = [row];
      const content = this.$t('message.deseja_reprovar');
      this.setDialogContent(content, this.openDialogJustificativaReprovar, this.dialog.from);
      this.openDialog(ref || this.dialog.ref);
    },
    requestAprovar() {
      const payload = {};
      payload.observacao = this.justificarOrcamento.observacao;
      const orcamentoListTemp = this.objetosSelecionados;
      if (orcamentoListTemp && orcamentoListTemp.length !== 0) {
        orcamentoListTemp.forEach((el, idx) => {
          if (el.idTipoWorkflow === 1) {
            this.aprovarOrcamento(el, idx, payload);
          }
          if (el.idTipoWorkflow === 3) {
            this.aprovarAjuste(el, idx, payload);
          }
          if (el.idTipoWorkflow === 4) {
            this.aprovarTransferencia(el, idx, payload);
          }
        });
      }
    },
    aprovarTransferencia(el, idx, payload) {
      const id = el.idOrcamento;
      this.workflowTransferenciaResources.aprovar({ id }, payload)
      .then(() => {
        this.limparSelecao();
        this.filtrar();
        this.$toast.create(this.$t('message.transferencia_aprovado'), 'snack', 3E3);
      })
      .catch((err) => {
        this.$error(this, err);
      });
    },
    aprovarAjuste(el, idx, payload) {
      const idAjuste = el.idOrcamento;
      this.workflowAjusteVerbaResources.aprovar({ idAjuste }, payload)
      .then(() => {
        this.limparSelecao();
        this.filtrar();
        this.$toast.create(this.$t('message.ajuste_verba_aprovado'), 'snack', 3E3);
      })
      .catch((err) => {
        this.$error(this, err);
      });
    },
    aprovarOrcamento(el, idx, payload) {
      const idOrcamento = el.idOrcamento;
      this.workflowOrcamentoResources.aprovar({ idOrcamento }, payload)
      .then(() => {
        this.limparSelecao();
        this.filtrar();
        this.$toast.create(this.$t('message.orcamento_aprovado'), 'snack', 3E3);
      })
      .catch((err) => {
        this.$error(this, err);
      });
    },
    requestReprovar() {
      const payload = {};
      payload.observacao = this.justificarOrcamento.observacao;
      const orcamentoListTemp = this.objetosSelecionados;
      if (orcamentoListTemp && orcamentoListTemp.length !== 0) {
        orcamentoListTemp.forEach((el, idx) => {
          if (el.idTipoWorkflow === 1) {
            this.reprovarOrcamento(el, idx, payload);
          }
          if (el.idTipoWorkflow === 3) {
            this.reprovarAjuste(el, idx, payload);
          }
          if (el.idTipoWorkflow === 4) {
            this.reprovarTransferencia(el, idx, payload);
          }
        });
      }
    },
    reprovarTransferencia(el, idx, payload) {
      const id = el.idOrcamento;
      this.workflowTransferenciaResources.reprovar({ id }, payload)
      .then(() => {
        if (idx === (this.objetosSelecionados.length - 1)) {
          this.limparSelecao();
          this.filtrar();
          this.$toast.create(this.$t('message.transferencia_reprovado'), 'snack', 3E3);
        }
      })
      .catch((err) => {
        this.$error(this, err);
      });
    },
    reprovarAjuste(el, idx, payload) {
      const idAjuste = el.idOrcamento;
      this.workflowAjusteVerbaResources.reprovar({ idAjuste }, payload)
      .then(() => {
        if (idx === (this.objetosSelecionados.length - 1)) {
          this.limparSelecao();
          this.filtrar();
          this.$toast.create(this.$t('message.ajuste_verba_reprovado'), 'snack', 3E3);
        }
      })
      .catch((err) => {
        this.$error(this, err);
      });
    },
    reprovarOrcamento(el, idx, payload) {
      const idOrcamento = el.idOrcamento;
      this.workflowOrcamentoResources.reprovar({ idOrcamento }, payload)
      .then(() => {
        if (idx === (this.objetosSelecionados.length - 1)) {
          this.limparSelecao();
          this.filtrar();
          this.$toast.create(this.$t('message.orcamento_reprovado'), 'snack', 3E3);
        }
      })
      .catch((err) => {
        this.$error(this, err);
      });
    },
    toggleSelecaoGeral(selecao) {
      this.filteredList.forEach((item) => {
        item.selecionado = selecao;
      });
      this.objetosSelecionados = !selecao ? [] : ([...this.filteredList]);

      this.requestPermiteAprovar();
      this.requestPermiteReprovar();
    },
    toggleSelecaoUnica(row) {
      setTimeout(() => {
        const selecao = row.selecionado;
        if (selecao) {
          this.objetosSelecionados.push(row);
          this.requestPermiteAprovar();
          this.requestPermiteReprovar();
          return;
        }

        let indexO = null;
        this.objetosSelecionados.forEach((obj, index) => {
          if (obj.idWorkflow === row.idWorkflow) {
            indexO = index;
          }
        });
        this.objetosSelecionados.splice(indexO, 1);
        this.requestPermiteAprovar();
        this.requestPermiteReprovar();
      });
    },
    requestPermiteAprovar() {
      this.podeAprovar = false;
      const lista = this.objetosSelecionados;
      if (!lista || lista.length === 0) {
        this.podeAprovar = false;
        return;
      }
      if (lista) {
        this.podeAprovar = true;
        lista.forEach((el) => {
          if (el.statusFluxo !== 'AGUARDANDO_APROVACAO') {
            this.podeAprovar = false;
          }
        });
      }
    },
    requestPermiteReprovar() {
      this.podeReprovar = false;
      const lista = this.objetosSelecionados;
      if (!lista || lista.length === 0) {
        this.podeReprovar = false;
        return;
      }
      if (lista) {
        this.podeReprovar = true;
        lista.forEach((el) => {
          if (el.statusFluxo !== 'AGUARDANDO_APROVACAO') {
            this.podeReprovar = false;
          }
        });
      }
    },
    setDialogContent(content, action, from, title) {
      this.dialog.content = content;
      this.dialog.action = action;
      this.dialog.title = title || this.$t('label.atencao');
      this.dialog.from = from || this.dialog.from;
    },
    openDialog(ref) {
      this.$refs[ref].open();
    },
    closeDialog(ref, cb) {
      this.$refs[ref].close();
      if (cb) {
        cb();
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/custom/abbrasil/spa/dashboard/cadeia/orcamento/OrcamentoTabelaDash.vue?vue&type=script&lang=js&